import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { BaseComponent, MessageBus } from 'src/app/shared';

@Component({
    selector: 'app-sticky-menu',
    template: `<div
    class="tw-w-full tw-bg-[var(--sed-open-grey-color)] tw-p-5"
    #stickyMenu
  >
    <div [style.padding-top.px]="padding"></div>
    <div #anchorMenuContent class="headingbold app-uppercase">
      <ng-content> </ng-content>
    </div>
  </div>`,
    styles: [
        `
      .app-lc-sticky-link a.active-sidelink {
        color: var(--sed-warm-white-color) !important;
      }
    `,
    ],
    standalone: false
})
export class StickyMenuComponent
  extends BaseComponent
  implements OnInit, AfterViewInit
{
  padding: number = 0;

  offset: number = 0;

  private observer: IntersectionObserver;

  @ViewChild('anchorMenuContent') menuContent: ElementRef;
  @Input() currentSection: string;
  @Output() sectionChange = new EventEmitter<string>();

  constructor(private messageBus: MessageBus) {
    super();
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.target.id !== this.currentSection) {
            this.currentSection = entry.target.id;
            this.sectionChange.emit(this.currentSection);
          }
        });
      },
      {
        rootMargin: '-50% 0px -50% 0px',
        threshold: 0,
      }
    );
  }

  ngOnInit(): void {
    // get initial offet of content

    this.subs.sink = this.messageBus
      .topic('layout:scroll')
      //.pipe(auditTime(0))
      .subscribe((event) => {
        if (document.getElementById('endOfElement').getBoundingClientRect().top > 600) {
          if (event.target.scrollTop > this.offset - 40) {
            this.padding = event.target.scrollTop - this.offset + 40;
          } else {
            this.padding = 0;
          }
        }
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const rect = this.menuContent.nativeElement.getBoundingClientRect();
      this.offset = rect.y - 80;
      this.observeSections();
    }, 0);
  }

  private observeSections() {
    const sections = document.querySelectorAll('[id^="lc-"]');
    sections.forEach((section) => {
      this.observer.observe(section);
    });
  }

  scrollToSection(sectionId: string) {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setTimeout(() => {
      this.currentSection = sectionId;
      this.sectionChange.emit(this.currentSection);
    }, 300);
  }
}
